import { useInfiniteQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { DeviceEventItem } from "../_types/devices.types";

type EventsMeta = {
  nextCursor: string | null;
  limit: number;
};

export const useDeviceEventsQuery = (deviceId: string | null) => {
  return useInfiniteQuery({
    queryKey: ["device-events", deviceId],
    queryFn: async ({ pageParam }: { pageParam: string | undefined }) => {
      const response = await axiosInstance.get<ApiResponse<DeviceEventItem[], EventsMeta>>(
        `/v2/devices/${deviceId}/events`,
        {
          params: {
            limit: 30,
            ...(pageParam ? { cursor: pageParam } : {}),
          },
        }
      );
      return {
        items: response.data.data ?? [],
        nextCursor: response.data.meta?.nextCursor ?? null,
      };
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    enabled: Boolean(deviceId),
  });
};
